import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class PackagingMaterialSearchService {

    constructor(private config: AppConfig, private http: Http) { }
    private apiUrl: string = this.config.get('apiUrl') + 'PackagingMaterial';

    // TODO send parameters to api
    listOfMaterialSearch(searchMHNo: string,
        searchMHDescription: string,
        searchStatusIds: string,
        searchOwnerId: number,
        searchLengthFrom: number,
        searchLengthTo: number,
        searchWidthFrom: number,
        searchWidthTo: number,
        searchHeightFrom: number,
        searchHeightTo: number): Observable<IReturnObject> {

        const url = `${this.apiUrl}/ListOfMaterialSearch/?searchMHNo=${searchMHNo}`
            + `&searchMHDescription=` + searchMHDescription
            + `&searchStatusIds=` + searchStatusIds
            + `&searchOwnerId=` + searchOwnerId
            + `&searchLengthFrom=` + searchLengthFrom
            + `&searchLengthTo=` + searchLengthTo
            + `&searchWidthFrom=` + searchWidthFrom
            + `&searchWidthTo=` + searchWidthTo
            + `&searchHeightFrom=` + searchHeightFrom
            + `&searchHeightTo=` + searchHeightTo;

        return this.http.get(url)
            .map((response, Response) => <IReturnObject>response.json());
    }
}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/packaging-material-search/packaging-material-search.service.ts